<template>
  <v-card :loading="loading">
    <v-card-text class="pa-2 caption black--text d-flex justify-space-between">
      <apexchart type="donut" :height="155" :options="chartOptions" :series="series" />
      <v-btn
        icon
        @click="openUsersDialog = true"
      >
        <v-icon>
          {{ mdiAccountMultiple }}
        </v-icon>
      </v-btn>
    </v-card-text>
    <input-methods-filtered-by-users-dialog
      v-if="openUsersDialog"
      @close="openUsersDialog = false"
    />
  </v-card>
</template>

<script>
import helper from '../../plugins/helpers/mixin-helper'
import InputMethodsFilteredByUsersDialog from './inputMethodsFilteredByUsersDialog.vue';
import { mdiAccountMultiple } from '@mdi/js'
export default {
  mixins: [
    helper
  ],
  components: {
    InputMethodsFilteredByUsersDialog
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    series: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      mdiAccountMultiple,
      openUsersDialog: false,
      chartOptions: {
        chart: {
          type: 'donut',
        },
        title: {
          text: 'Input methods by playtime'
        },
        labels: this.categories,
        tooltip: {
          y: {
            formatter: (val) => {
              return this.timeToString(val)
            }
          }
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  fontSize: '14px',
                  offsetY: -5,
                },
                total: {
                  fontSize: '14px',
                  fontWeight: 600,
                  showAlways: true,
                  show: true,
                  formatter: (w) => {
                    const seconds =  w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0)
                    return this.timeToString(seconds)
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  watch: {
    categories (val) {
      this.chartOptions = {
        ...this.chartOptions,
        labels: val
      }
    }
  }
}
</script>